import { render, staticRenderFns } from "./associated.vue?vue&type=template&id=589a514c&scoped=true"
import script from "./associated.vue?vue&type=script&lang=js"
export * from "./associated.vue?vue&type=script&lang=js"
import style0 from "./associated.vue?vue&type=style&index=0&id=589a514c&prod&lang=scss&scoped=true"
import style1 from "./associated.vue?vue&type=style&index=1&id=589a514c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a514c",
  null
  
)

export default component.exports